module.exports = "<h4 class=\"action-title mb-0 mt-0\">{{t('actionVpn.enableOpenVpn')|e}}</h4>\n<p>{{yesNoVal(enabled)|e}}</p>\n";
